import { ResourceType } from "@common/types/auditLog";
import { APIProcessName, SQSProcessName } from "../process-names";
import { HistoryField, HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import { TASK_FIELDS, WORK_ITEM_HISTORY_FIELDS } from "./source-fields";
import { ALL_HISTORY_SCOPES } from "./organization-history-sources";

export const taskSources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.TASK_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    {
        sourceType: APIProcessName.TASK_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    {
        sourceType: APIProcessName.TASK_DELETE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    {
        sourceType: APIProcessName.CLOSE_TEMPLATE_APPLY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLOSE,
                fields: [HistoryField.NAME, HistoryField.START_DATE],
            },
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    {
        sourceType: APIProcessName.DELETE_CLOSE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    ...[
        APIProcessName.TASK_BULK_UPDATE,
        SQSProcessName.TASK_BULK_UPDATES,
        APIProcessName.CANCEL_CLOSE,
    ].map((sourceType): HistorySourceTypeConfig => ({
        sourceType,
        resourceTypeConfigs: [
            { resourceType: ResourceType.TASK, fields: TASK_FIELDS },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    })),
    {
        sourceType: APIProcessName.UPDATE_CLOSE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.CLOSE,
                fields: [...WORK_ITEM_HISTORY_FIELDS],
            },
            { resourceType: ResourceType.TASK, fields: TASK_FIELDS },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: SQSProcessName.CREATE_ACCRUAL_REVIEW_TASKS_FOR_ENTITY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
    {
        sourceType: SQSProcessName.CREATE_SCHEDULE_REVIEW_TASKS_FOR_ENTITY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.TASK,
                fields: TASK_FIELDS,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
        scopes: ALL_HISTORY_SCOPES,
    },
];
